import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from '../api/client.js';
import Logo from '../components/Logo.jsx';
import { Loading } from '../components/UI.jsx';

// Vista publica del estado de una reparacion (se comparte por WhatsApp).
// A proposito muestra UNICAMENTE el numero y el estado: nada de cliente,
// dispositivo, descripcion, montos ni fechas.
const ESTADOS = [
  { value: 'recibido', label: 'Recibido', bg: 'var(--info-bg)', color: 'var(--info)' },
  { value: 'diagnostico', label: 'En diagnostico', bg: 'var(--accent-soft)', color: 'var(--accent-texto)' },
  { value: 'esperando_repuesto', label: 'Esperando repuesto', bg: 'var(--warning-bg)', color: 'var(--warning)' },
  { value: 'reparando', label: 'En reparacion', bg: 'rgba(139, 92, 246, 0.16)', color: 'var(--purple-400)' },
  { value: 'listo', label: 'Listo para retirar', bg: 'var(--success-bg)', color: 'var(--success)' },
  { value: 'entregado', label: 'Entregado', bg: 'var(--surface-2)', color: 'var(--text-muted)' },
  { value: 'no_reparable', label: 'No reparable', bg: 'var(--danger-bg)', color: 'var(--danger)' },
];
const ESTADO_INFO = Object.fromEntries(ESTADOS.map((e) => [e.value, e]));

export default function ReparacionPublica() {
  const { token } = useParams();
  const [reparacion, setReparacion] = useState(undefined);
  const [error, setError] = useState(false);

  useEffect(() => {
    api.get(`/publico/reparacion/${token}`)
      .then((r) => setReparacion(r.data.data))
      .catch(() => setError(true));
  }, [token]);

  const info = reparacion ? (ESTADO_INFO[reparacion.estado] || { label: reparacion.estado, bg: 'var(--accent-soft)', color: 'var(--accent-texto)' }) : null;

  return (
    <div style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', padding: 20 }}>
      <div className="card fade-up" style={{ padding: 32, maxWidth: 380, width: '100%', background: 'var(--surface-solid)', textAlign: 'center' }}>
        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 20 }}>
          <Logo size={32} />
        </div>

        {error ? (
          <>
            <h2 style={{ marginBottom: 8 }}>No encontramos esta reparacion</h2>
            <p className="muted">Revisa el link que te compartieron. Si el problema sigue, contacta al taller.</p>
          </>
        ) : reparacion === undefined ? (
          <Loading texto="Buscando el estado..." />
        ) : (
          <>
            <p className="muted" style={{ fontSize: 13, marginBottom: 6, letterSpacing: '0.02em' }}>Reparacion</p>
            <h2 style={{ fontSize: 22, marginBottom: 22, fontFamily: 'var(--font-display)' }}>{reparacion.numero}</h2>
            <span
              className="badge"
              style={{
                background: info.bg, color: info.color,
                fontSize: 18, padding: '12px 24px', fontWeight: 700, borderRadius: 999,
                display: 'inline-block',
              }}
            >
              {info.label}
            </span>
          </>
        )}
      </div>
    </div>
  );
}
